import {
  Route,
  Routes
} from 'react-router-dom';
import { Login } from "../pages/login/login";
import { PrivateRoute } from "../components/privateRoute/privateRoute";
import { Main } from "../pages/main/main";
import { Admin } from "../pages/admin/admin";
import { Logout } from "../pages/logout/logout";
import { AdminRoute } from "../components/adminRoute/adminRoute";

export const useRoutes = () => {

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route element={<PrivateRoute />}>
        <Route path="/" element={<Main />} />
        <Route path="/logout" element={<Logout />} />

        <Route element={<AdminRoute/>}>
          <Route path='/admin' element={<Admin />} />
        </Route>
      </Route>

    </Routes>
  )
}